import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { ModeToggle } from '../components/ModeToggle';
import { CaseStudies } from '../components/CaseStudies';
import { CareerTimeline } from '../components/CareerTimeline';
import { BridgeFramework } from '../components/BridgeFramework';
import { ThoughtLeadership } from '../components/ThoughtLeadership';
import { ExecutiveBioKit } from '../components/ExecutiveBioKit';
import { Contact } from '../components/Contact';
import { BioPrintView } from '../components/BioPrintView';
export function HomePage() {
  const [mode, setMode] = useState<'recruiter' | 'executive'>('recruiter');
  const handleModeChange = (newMode: 'recruiter' | 'executive') => {
    setMode(newMode);
  };
  return <>
      {/* Skip to content — accessibility */}
      <a href="#main-content" className="skip-link" data-id="element-621">
        Skip to main content
      </a>

      {/* Sticky navigation */}
      <Navigation mode={mode} onModeChange={handleModeChange} data-id="element-622" />

      {/* Main content */}
      <main id="main-content" tabIndex={-1} data-id="element-623">
        {/* Hero / Vision */}
        <Hero data-id="element-624" />

        {/* Enterprise Impact — anchor for hero CTA */}
        <div id="impact" data-id="element-625" />

        {/* Leadership — Recruiter / Executive mode */}
        <ModeToggle mode={mode} data-id="element-626" />

        {/* Case Studies */}
        <CaseStudies data-id="element-627" />

        {/* Career Timeline */}
        <CareerTimeline data-id="element-628" />

        {/* Bridge Framework™ */}
        <BridgeFramework data-id="element-629" />

        {/* Thought Leadership */}
        <ThoughtLeadership data-id="element-630" />

        {/* Executive Bio Kit */}
        <ExecutiveBioKit data-id="element-631" />

        {/* Contact */}
        <Contact data-id="element-632" />
      </main>

      {/* Print-only bio document — hidden on screen, rendered on print/save as PDF */}
      <BioPrintView data-id="element-633" />

      {/* Footer */}
      <footer className="bg-[#1C1F23] border-t border-[#F7F7F5]/5 py-8" role="contentinfo" aria-label="Site footer" data-id="element-634">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-635">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-636">
            <div className="flex items-center gap-2" data-id="element-637">
              <span className="font-heading font-bold text-[#F7F7F5] text-sm" data-id="element-638">
                Michael K. <span className="text-[#B08D57]" data-id="element-639">Bigos</span>
              </span>
              <span className="text-[#F7F7F5]/20 text-sm" data-id="element-640">·</span>
              <span className="font-body text-[#F7F7F5]/40 text-xs" data-id="element-641">
                Senior Director | Product, Experience & Brand Systems
              </span>
            </div>
            <div className="flex items-center gap-4" data-id="element-642">
              <span className="font-body text-[#F7F7F5]/30 text-xs" data-id="element-643">
                Section 508 · WCAG AA · ADA Compliant
              </span>
              <span className="text-[#F7F7F5]/20 text-xs" data-id="element-644">·</span>
              <span className="font-body text-[#F7F7F5]/30 text-xs" data-id="element-645">
                © {new Date().getFullYear()} Michael K. Bigos
              </span>
            </div>
          </div>
        </div>
      </footer>
    </>;
}